import store from "../store";

export default async function is_junior_retoucher({ next, router }) {
    await store.dispatch('profile/role');
    let role = await store.getters['profile/role'];
    if (role !== 'junior-retoucher') {
        return router.push({ name: "User Profile" });
    }

    return next();
}
